import React, { useEffect, useState } from 'react';
import fetch from 'node-fetch';

import {
  Root,
  Container,
  Title,
  Icon,
  Grid,
  GridItem,
  GridLink,
  GridImg,
  TitleContainer,
  IconLink,
  DesktopIcon,
  DesktopIconLink,
  MobileIconLink,
  MobileIcon,
} from './Instagram.style';

import LoadingSrc from '../../images/loading.gif';

const Instagram = () => {
  const [media, setMedia] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://${process.env.GATSBY_API_DOMAIN}/instafeed`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      ).then(results => results.json());
      // backfill if posted less than 9
      let media = [...response];
      if (response.length < 9) {
        for (let ii = 0; ii < 9 - response.length; ii += 1) {
          media.push({
            id: 'xx' + ii,
            thumbnail_url: `/insta/Asset ${ii + 2}.png`,
            caption: '',
          });
        }
      }
      // console.info({media})
      setMedia(media);
      setIsLoading(false);
    } catch (error) {
      // TODO: an error occurred
      // console.info({ error });
      setIsLoading(false);
    }
  }, []);

  const IgIcon = (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="instagram-icon-title"
    >
      <title id="instagram-icon-title">Instagram Icon</title>
      <path
        d="M 18.021 35.95 C 16.129 35.95 14.237 35.975 12.345 35.943 C 10.774 35.969 9.203 35.818 7.663 35.497 C 5.079 34.947 2.854 33.32 1.542 31.025 C 0.829 29.758 0.387 28.356 0.243 26.909 C 0.045 24.713 -0.033 22.509 0.013 20.303 C 0.005 17.881 0.008 15.458 0.034 13.037 C 0.011 11.491 0.113 9.947 0.337 8.417 C 0.709 5.702 2.242 3.282 4.537 1.783 C 5.895 0.892 7.457 0.362 9.076 0.24 C 10.978 0.094 12.889 0.03 14.797 0.007 C 17.575 -0.027 20.353 -0.009 23.131 0.02 C 24.72 -0.008 26.309 0.111 27.876 0.377 C 30.671 0.835 33.108 2.54 34.499 5.008 C 35.262 6.398 35.711 7.937 35.816 9.518 C 36.026 11.943 35.998 14.375 35.999 16.805 C 35.999 19.053 35.999 21.302 35.961 23.549 C 35.991 25.112 35.848 26.674 35.536 28.205 C 34.837 31.783 32.103 34.614 28.553 35.437 C 27.228 35.763 25.868 35.922 24.503 35.912 C 22.343 35.952 20.182 35.978 18.02 36.012 Z M 17.967 32.775 L 17.967 32.706 C 19.842 32.706 21.717 32.724 23.593 32.699 C 24.895 32.727 26.196 32.617 27.474 32.368 C 29.936 31.93 31.876 30.025 32.356 27.57 C 32.648 26.112 32.774 24.627 32.729 23.141 C 32.763 20.189 32.757 17.237 32.748 14.284 C 32.787 12.531 32.701 10.777 32.488 9.037 C 32.2 6.278 30.11 4.047 27.375 3.579 C 25.98 3.333 24.565 3.225 23.147 3.256 C 20.631 3.222 18.115 3.228 15.593 3.23 C 13.527 3.186 11.461 3.258 9.404 3.449 C 8.266 3.553 7.17 3.933 6.21 4.556 C 4.803 5.52 3.851 7.02 3.579 8.705 C 3.352 10.015 3.251 11.343 3.276 12.671 C 3.26 16.482 3.276 20.293 3.302 24.104 C 3.287 25.225 3.39 26.343 3.614 27.442 C 3.991 29.598 5.509 31.378 7.577 32.092 C 8.716 32.473 9.91 32.663 11.109 32.654 C 13.401 32.708 15.683 32.737 17.967 32.775 Z M 27.243 17.977 C 27.251 25.09 19.557 29.543 13.395 25.993 C 7.232 22.444 7.222 13.555 13.377 9.992 C 14.766 9.189 16.339 8.76 17.943 8.75 C 23.059 8.732 27.221 12.862 27.243 17.977 Z M 18.008 23.982 C 18.009 23.982 18.007 23.982 18.008 23.982 Z M 23.198 14.99 C 20.891 10.993 15.122 10.992 12.814 14.989 C 12.273 15.925 11.996 16.99 12.01 18.07 C 12.069 21.345 14.734 23.972 18.008 23.982 C 22.621 23.981 25.505 18.986 23.198 14.99 Z M 25.457 8.363 C 25.469 6.703 27.274 5.677 28.708 6.518 C 30.14 7.359 30.125 9.436 28.68 10.256 C 28.348 10.446 27.969 10.543 27.585 10.537 C 26.403 10.512 25.458 9.547 25.457 8.363 Z"
        fill="#141f35"
      ></path>
    </svg>
  );

  const Items = media.map(itm => (
    <GridItem key={itm.id}>
      {itm.permalink ? (
        <GridLink href={itm.permalink} target="_blank">
          <GridImg src={itm.thumbnail_url || itm.media_url} alt={itm.caption} />
        </GridLink>
      ) : (
        <GridLink as="div">
          <GridImg src={itm.thumbnail_url || itm.media_url} alt={itm.caption} />
        </GridLink>
      )}
    </GridItem>
  ));

  return (
    <Root>
      <Container>
        <TitleContainer>
          <Title>
            <span>Instagram</span>
          </Title>
          <DesktopIconLink
            href="https://www.instagram.com/jamesownbyreserve/"
            target="_blank"
            className="--desktop"
          >
            <DesktopIcon className="--desktop">{IgIcon}</DesktopIcon>
          </DesktopIconLink>
        </TitleContainer>

        {isLoading ? <img src={LoadingSrc} alt="" /> : <Grid>{Items}</Grid>}

        <MobileIconLink href="https://www.instagram.com/jamesownbyreserve/" target="_blank" className="--mobile">
          <MobileIcon className="--mobile">{IgIcon}</MobileIcon>
        </MobileIconLink>
      </Container>
    </Root>
  );
};

export default Instagram;
